"use client";
import {
  EmailIcon,
  FacebookIcon,
  HeaderTopsvg,
  InstaIcon,
  Logo,
  PhoneIcon,
  TwitterIcon,
  WhatsappIcon,
} from "@/assets/icons";
import { usePathname, useRouter } from "next/navigation";
import menu from "@/assets/Image/comman/menu.png";
import { JSX, useState } from "react";
import Image from "next/image";
import { Drawer } from "@mui/material";
interface ContactItem {
  icon: JSX.Element;
  title: string;
  href: string;
}
export const Header = () => {
  const pathname = usePathname();
  console.log("pathnamepathnamepathname -------", pathname);

  const router = useRouter();
  const [open, setOpen] = useState(false);

  const toggleDrawer = (newOpen: boolean) => () => {
    setOpen(newOpen);
  };
  const contact: ContactItem[] = [
    {
      icon: <EmailIcon />,
      title: "info@mstourism.co.in",
      href: "mailto:info@mstourism.co.in",
    },
    {
      icon: <PhoneIcon />,
      title: "+91 99786 04488",
      href: "tel:+91 99786 04488",
    },
  ];
  const socialIcon = [
    {
      icon: <InstaIcon />,
      url: "https://www.instagram.com/ms_tourism1/"
    },
    {
      icon: <FacebookIcon />,
      url: "https://www.facebook.com/mstoosdfsdf/"
    },
    {
      icon: <TwitterIcon />,
      url: "https://www.instagram.com/ms_tourism1/"
    },
    {
      icon: <WhatsappIcon />,
      url: "https://wa.me/919978604488?text=hello"
    },
  ];
  const linkdata = [
    {
      title: "Home",
      navigation: "/",
    },
    {
      title: "About",
      navigation: "/about",
    }, 
    {
      title: "International",
      navigation: "/international-tour",
    },
    {
      title: "Visa",
      navigation: "/visa",
    },
    {
      title: "Domestic",
      navigation: "/domestic-tour",
    },
    {
      title: "Pilgrimages",
      navigation: "/pilgrimage-tour",
    },
    {
      navigation: "/flight-booking",
      title: "Flights",
    },
    {
      navigation: "/hotel-booking",
      title: "Hotels",
    },
    {
      title: "Cruise",
      navigation: "/cruise",
    }, 
    {
      title: "Car Rental",
      navigation: "/car-rental",
    },
  ];

  return (
    <div
      className=" w-full bg-white py-2 lg:py-0"
      style={{ boxShadow: "0px 3px 4px 0px #00000040" }}>
      <div className="container relative">
        <div className="flex justify-between items-center   ">
          <div className="hidden lg:flex items-center gap-6">
            {contact.map((item, index) => (
              <a
                key={index}
                href={item.href}
                className="flex items-center gap-2 text-dark-gray hover:text-[#161D3A] transition"
                aria-label={item.title}>
                {item.icon}
                <p className="font-bold ">{item.title}</p>
              </a>
            ))}
          </div>
          <div className="cursor-pointer " onClick={() => router.push("/")}>
            <Logo />
          </div>
          <div className="flex lg:hidden">
            <Image
              src={menu}
              alt="menu"
              className="w-9"
              onClick={toggleDrawer(true)}
            />

            <Drawer open={open} onClose={toggleDrawer(false)}>
              <div className="w-80 p-9">
                <Logo />

                <div className=" flex flex-col gap-3 xl:gap-6 pt-5">
                  {linkdata.map((i, n) => {
                    const isActive = Boolean(
                      i.navigation &&
                      pathname &&
                      (i.navigation === "/" ? pathname === "/" : pathname.startsWith(i.navigation))
                    );

                    return (
                      <div
                        key={n}
                        onClick={() => {
                          router.push(i.navigation);
                          setOpen(false);
                        }}
                        className={`cursor-pointer ${isActive ? "text-[#3C51A0]" : "text-black"
                          } transition`}>
                        <h5 className="font-bold">{i.title}</h5>
                      </div>
                    );
                  })}
                </div>
                <div className="flex gap-4 items-center icons py-4">
                  {socialIcon.map((n, i) => {
                    return (
                      <div
                        key={i}
                        onClick={() => setOpen(false)}
                        className="w-11 h-11 flex justify-center items-center"
                        style={{ border: "1px solid", borderRadius: "100px" }}>
                        {n.icon}
                      </div>
                    );
                  })}
                </div>
                <button
                  className="btn w-full"
                  onClick={() => {
                    router.push("/contact-us");
                    setOpen(false);
                  }}>
                  Contact Us
                </button>
              </div>
            </Drawer>
          </div>
          <div className="hidden lg:flex gap-4 items-center icons">
            {socialIcon.map((n, i) => {
              return (
                // <div key={i} className="socialIcon">
                //   {n.icon}
                // </div>
                <a
                  key={i}
                  href={n.url}
                  // https://www.facebook.com/mstoosdfsdf/
                  target="_blank"
                  rel="noopener noreferrer"
                  className="socialIcon"
                >
                  {n.icon}
                </a>
              );
            })}
            <button className="btn" onClick={() => router.push("/contact-us")}>
              Contact Us
            </button>
          </div>
        </div>
        <div className="absolute bottom-0  top-[74px] xl:top-[84px]  end-0 left-0 hidden lg:flex justify-center z-10">
          <div className="relative">
            <HeaderTopsvg />
            <div className="absolute top-10 left-0 end-0 flex items-center justify-center gap-3 xl:gap-6">
              {linkdata.map((i, n) => {
                const isActive = Boolean(
                  i.navigation &&
                  pathname &&
                  (i.navigation === "/" ? pathname === "/" : pathname.startsWith(i.navigation))
                );


                return (
                  <div
                    key={n}
                    onClick={() => router.push(i.navigation)}
                    className={`cursor-pointer ${isActive ? "text-[#3C51A0]" : "text-black"
                      } transition`}>
                    <h5 className="font-bold">{i.title}</h5>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
